/* Noir — thème Shopify — v46 (CRO mobile) */
(function(){
"use strict";
const $ = s => document.querySelector(s);
const LNG=(document.documentElement.lang||"fr").slice(0,2);
const I18N=Object.assign({added:"Ajouté ✓",empty:"Votre panier est vide.",cupEyebrow:"Céramique — fabriquée en France",perPiece:"/ pièce",dec:"Réduire",inc:"Augmenter",remove:"Retirer",shipMore:"Plus que %s pour la livraison offerte en France.",shipOk:"Livraison offerte en France ✓",instore:"Également en vente dans nos coffee shops.",chooseGrind:"Choisir la mouture…",grindReq:"Choisissez une mouture."},window.NOIR_I18N||{});
const pickL=v=>v&&typeof v==="object"&&!Array.isArray(v)?(v[LNG]||v.en||v.fr):v;
const fmtc = c => (c/100).toFixed(2).replace(".",",") + " €";
const hkey = h => (h||"").replace(/-\d+$/,"");
function imgFallback(im){
  im.addEventListener("error", function h(){
    if(im.dataset.fb1){ im.src = im.dataset.fb1; im.removeAttribute("data-fb1"); }
    else if(im.dataset.fb2){ im.src = im.dataset.fb2; im.removeAttribute("data-fb2"); }
    else { im.removeEventListener("error", h); im.style.visibility="hidden"; const c=im.closest(".cell"); if(c) c.classList.add("noimg"); }
  });
}

/* ---- libellés & termes traduits (fiche / popup) ---- */
const LBL={Origin:{fr:"Origine",en:"Origin",es:"Origen"},Producer:{fr:"Producteur",en:"Producer",es:"Productor"},Variety:{fr:"Variété",en:"Variety",es:"Variedad"},Location:{fr:"Lieu",en:"Location",es:"Lugar"},Altitude:{fr:"Altitude",en:"Altitude",es:"Altitud"},Process:{fr:"Process",en:"Process",es:"Proceso"},Drying:{fr:"Séchage",en:"Drying",es:"Secado"}};
const GL={a:{fr:"Acidité",en:"Acidity",es:"Acidez"},b:{fr:"Corps",en:"Body",es:"Cuerpo"},s:{fr:"Sucrosité",en:"Sweetness",es:"Dulzor"}};
const TERM={
 "Washed":{fr:"Lavé",es:"Lavado"},
 "Fully washed":{fr:"Entièrement lavé",es:"Lavado completo"},
 "Natural":{fr:"Nature",es:"Natural"},
 "Pulped natural":{fr:"Pulped natural",es:"Pulped natural"},
 "Natural anaerobic":{fr:"Nature anaérobie",es:"Natural anaeróbico"},
 "Anaerobic fermentation — 60h":{fr:"Fermentation anaérobie — 60 h",es:"Fermentación anaeróbica — 60 h"},
 "Natural, sugar cane decaffeination":{fr:"Nature, décaféination à la canne à sucre",es:"Natural, descafeinado con caña de azúcar"},
 "Sugar cane":{fr:"Canne à sucre",es:"Caña de azúcar"},
 "Raised African beds":{fr:"Lits africains surélevés",es:"Camas africanas elevadas"},
 "Raised african beds":{fr:"Lits africains surélevés",es:"Camas africanas elevadas"},
 "African beds":{fr:"Lits africains",es:"Camas africanas"},
 "Raised beds":{fr:"Lits surélevés",es:"Camas elevadas"},
 "Dried on raised beds":{fr:"Séché sur lits surélevés",es:"Secado en camas elevadas"},
 "Patio and mechanical":{fr:"Patio et séchoir mécanique",es:"Patio y secado mecánico"},
 "Parabolic and mechanical dryer":{fr:"Séchoir parabolique et mécanique",es:"Secador parabólico y mecánico"},
 "Greenhouse":{fr:"Serre",es:"Invernadero"},
 "Brazil, Minas Gerais":{fr:"Brésil, Minas Gerais",es:"Brasil, Minas Gerais"},
 "El Salvador, Chalatenango":{fr:"Salvador, Chalatenango",es:"El Salvador, Chalatenango"},
 "Rwanda, Western Province":{fr:"Rwanda, Province de l'Ouest",es:"Ruanda, Provincia Occidental"},
 "Peru, Amazonas Province":{fr:"Pérou, Amazonas",es:"Perú, Amazonas"},
 "Ethiopia, Yirgacheffe":{fr:"Éthiopie, Yirgacheffe",es:"Etiopía, Yirgacheffe"},
 "Ethiopia, Oromia":{fr:"Éthiopie, Oromia",es:"Etiopía, Oromia"},
 "Kenya, Embu County":{fr:"Kenya, comté d'Embu",es:"Kenia, Embu"},
 "Rwanda, Nyamasheke dist.":{fr:"Rwanda, district de Nyamasheke",es:"Ruanda, distrito de Nyamasheke"},
 "Colombia, Huila":{fr:"Colombie, Huila",es:"Colombia, Huila"},
 "Colombia, Tolima":{fr:"Colombie, Tolima",es:"Colombia, Tolima"},
 "Silva Family — Sitio da Torre":{fr:"Famille Silva — Sitio da Torre",es:"Familia Silva — Sitio da Torre"},
 "Kianyangi factory":{fr:"Station Kianyangi",es:"Estación Kianyangi"},
 "Nyamyumba Washing Station":{fr:"Station de lavage Nyamyumba",es:"Estación de lavado Nyamyumba"},
 "ASCISP Cooperative":{fr:"Coopérative ASCISP",es:"Cooperativa ASCISP"}
};
const trv = v => { const t=TERM[v]; if(t && t[LNG]) return t[LNG]; return LNG==="en" ? v : v.replace(/\s*masl\b/g," m"); };
const trl = k => (LBL[k] && LBL[k][LNG]) || k;
const specRows = specs => (specs||[]).map(s=>"<tr><td>"+trl(s[0])+"</td><td>"+trv(s[1])+"</td></tr>").join("");
const gaugeHtml = d => { const gv = v => Math.max(8,(v-1)/2*100).toFixed(0)+"%"; return [["a",d.a],["b",d.b],["s",d.s]].map(x=>'<div><span>'+GL[x[0]][LNG]+'</span><i data-v="'+gv(x[1])+'" style="--v:0%"></i></div>').join(""); };

/* ---- données produit (specs étiquette) — clé = handle Shopify ---- */
const DATA = {
 "sitio-da-torre":{color:"#6a1932",a:1,b:3,s:3,origin:{fr:"Brésil — Minas Gerais",en:"Brazil — Minas Gerais",es:"Brasil — Minas Gerais"},process:"Pulped natural",flav:{fr:"Amande, myrtille, chocolat",en:"Almond, blueberry, chocolate",es:"Almendra, arándano, chocolate"},sca:"85",
  specs:[["Origin","Brazil, Minas Gerais"],["Producer","Silva Family — Sitio da Torre"],["Variety","Yellow Bourbon"],["Location","Mantiqueira de Minas, Carmo"],["Altitude","1100–1300 masl"],["Process","Pulped natural"],["Drying","Patio and mechanical"]]},
 "los-chelazos":{color:"#a05621",a:1.5,b:2.5,s:2.5,origin:{fr:"Salvador — Chalatenango",en:"El Salvador — Chalatenango",es:"El Salvador — Chalatenango"},process:"Washed",flav:{fr:"Biscuit, thé noir, macadamia",en:"Biscuits, black tea, macadamia",es:"Galleta, té negro, macadamia"},sca:"85.75",
  specs:[["Origin","El Salvador, Chalatenango"],["Producer","Los Chelazos"],["Variety","Pacas, Catuai, Bourbon, Caturra"],["Location","La Palma, San Ignacio"],["Altitude","1200–1800 masl"],["Process","Washed"],["Drying","Dried on raised beds"]]},
 "nyamyumba":{color:"#2f51dc",a:2,b:2.5,s:3,origin:{fr:"Rwanda — Province de l'Ouest",en:"Rwanda — Western Province",es:"Ruanda — Provincia Occidental"},process:"Natural",flav:{fr:"Mûre, chocolat au lait, vanille",en:"Blackberry, milk chocolate, vanilla",es:"Mora, chocolate con leche, vainilla"},sca:"85.5",
  specs:[["Origin","Rwanda, Western Province"],["Producer","Nyamyumba Washing Station"],["Variety","Bourbon"],["Location","Rubavu, Nyamyumba"],["Altitude","1500–2000 masl"],["Process","Natural"],["Drying","Raised african beds"]]},
 "penachi":{color:"#3f0a78",a:1.5,b:2.5,s:3,origin:{fr:"Pérou — Amazonas",en:"Peru — Amazonas",es:"Perú — Amazonas"},process:"Washed",flav:{fr:"Chocolat, praliné, fruits tropicaux",en:"Chocolate, praline, tropical fruit",es:"Chocolate, praliné, fruta tropical"},sca:"85",
  specs:[["Origin","Peru, Amazonas Province"],["Producer","Comite Penachi, R. de Mendoza"],["Variety","Bourbon, Catuai, Caturra, Typica"],["Location","Chachapoyas, Chiliquin"],["Altitude","1400–2000 masl"],["Process","Washed"],["Drying","Raised african beds"]]},
 "chelbesa":{color:"#f5c1a8",a:4,b:2,s:3.5,origin:{fr:"Éthiopie — Yirgacheffe",en:"Ethiopia — Yirgacheffe",es:"Etiopía — Yirgacheffe"},process:"Washed",flav:{fr:"Kumquat, pêche, jasmin",en:"Kumquat, peach, jasmine",es:"Kumquat, melocotón, jazmín"},sca:"87",
  specs:[["Origin","Ethiopia, Yirgacheffe"],["Producer","Chelbesa — SNAP"],["Variety","Heirloom"],["Location","Gedeb, Gedeo"],["Altitude","1950–2200 masl"],["Process","Washed"],["Drying","Raised African beds"]]},
 "kianyangi":{color:"#fcca01",a:4.5,b:3,s:3.5,origin:{fr:"Kenya — Embu",en:"Kenya — Embu County",es:"Kenia — Embu"},process:"Fully washed",flav:{fr:"Fleur d'oranger, cassis, caramel",en:"Orange blossom, blackcurrant, caramel",es:"Azahar, grosella negra, caramelo"},sca:"87",
  specs:[["Origin","Kenya, Embu County"],["Producer","Kianyangi factory"],["Variety","Batian, Ruiru 11, SL28, SL34"],["Location","Manyatta"],["Altitude","1750 masl"],["Process","Fully washed"],["Drying","Raised African beds"]]},
 "gasharu":{color:"#94c689",a:3,b:2.5,s:3,origin:{fr:"Rwanda — Nyamasheke",en:"Rwanda — Nyamasheke",es:"Ruanda — Nyamasheke"},process:{fr:"Anaérobie 60 h",en:"Anaerobic 60 h",es:"Anaeróbico 60 h"},flav:{fr:"Mangue, raisin sec, éclats de cacao",en:"Mango, raisins, cocoa nibs",es:"Mango, pasas, nibs de cacao"},sca:"86.5",
  specs:[["Origin","Rwanda, Nyamasheke dist."],["Producer","Valentin Kimenyi"],["Variety","Red Bourbon"],["Location","Macuba, Gasharu"],["Altitude","1800–2110 masl"],["Process","Anaerobic fermentation — 60h"],["Drying","African beds"]]},
 "hambela-fw":{color:"#457376",a:2.5,b:2,s:2.5,origin:{fr:"Éthiopie — Guji",en:"Ethiopia — Guji",es:"Etiopía — Guji"},process:"Fully washed",flav:{fr:"Jasmin, orangina, abricot",en:"Jasmine, orangina, apricot",es:"Jazmín, naranja, albaricoque"},sca:"86.25",
  specs:[["Origin","Ethiopia, Oromia"],["Producer","Dimtu Coffee Industry"],["Variety","Heirloom — Grade 1"],["Location","Guji zone, Shakiso, Hambela"],["Altitude","1850–1950 masl"],["Process","Fully washed"],["Drying","Raised beds"]]},
 "las-brisas":{color:"#018c7f",a:3,b:2,s:2.5,origin:{fr:"Colombie — Huila",en:"Colombia — Huila",es:"Colombia — Huila"},process:{fr:"Natural anaérobie",en:"Natural anaerobic",es:"Natural anaeróbico"},flav:{fr:"Ananas, myrtille, caramel",en:"Pineapple, blueberry, caramel",es:"Piña, arándano, caramelo"},sca:"86.5",
  specs:[["Origin","Colombia, Huila"],["Producer","Wilmer Cuellar"],["Variety","Pacamara"],["Location","Acevedo, Las Brisas"],["Altitude","1600–1650 masl"],["Process","Natural anaerobic"],["Drying","Parabolic and mechanical dryer"]]},
 "nasa-deca":{color:"#d07d0c",a:1.5,b:2.5,s:2.5,origin:{fr:"Colombie — Tolima · Déca",en:"Colombia — Tolima · Decaf",es:"Colombia — Tolima · Descafeinado"},process:"Sugar cane",flav:{fr:"Figue séchée, canneberge, quark",en:"Dried figs, cranberry, quark",es:"Higo seco, arándano rojo, quark"},sca:"86",
  specs:[["Origin","Colombia, Tolima"],["Producer","ASCISP Cooperative"],["Variety","Caturra, colombia, castillo, typica"],["Location","Planadas and Gaitania, Nasa Wesx"],["Altitude","1700–2000 masl"],["Process","Natural, sugar cane decaffeination"],["Drying","Greenhouse"]]}
};

/* ---- panier AJAX — rendu optimiste : l'écran change tout de suite, le serveur confirme derrière ---- */
let CART = null;                 // dernier état connu du panier
const PENDING = {};              // key -> timer (regroupe les clics rapides +/−)
const clone = o => JSON.parse(JSON.stringify(o));
const parseMoney = s => { const n = String(s||"").replace(/[^\d,.]/g,"").replace(",","."); const v = parseFloat(n); return isNaN(v) ? 0 : Math.round(v*100); };
function openDrawer(){ $("#drawer").classList.add("open"); $("#overlay").classList.add("open"); document.body.style.overflow="hidden"; }
function closeDrawer(){ $("#drawer").classList.remove("open"); $("#overlay").classList.remove("open"); document.body.style.overflow=""; }

function renderCart(cart){
  CART = cart;
  const items = $("#cartItems"); if(!items) return;
  items.innerHTML = "";
  if(!cart.item_count){
    items.innerHTML = '<div class="cempty">'+I18N.empty+'</div>';
  } else {
    cart.items.forEach(li=>{
      const d = document.createElement("div"); d.className = "citem" + (li._tmp ? " pending" : "");
      const base = document.body.dataset.assets || "";
      const img = li.image ? li.image.replace(/(\.[a-z]+)(\?|$)/, "_120x$1$2")
                : (base ? base + hkey(li.handle) + ".webp" : "");
      d.innerHTML =
        '<img src="'+img+'" alt="" onerror="this.style.visibility=&quot;hidden&quot;">' +
        '<div><div class="ci-name">'+li.product_title+'</div>'+((li.variant_title&&li.variant_title!=="Default Title")?'<div class="ci-var">'+li.variant_title+'</div>':'')+'<div class="ci-price">'+fmtc(li.price)+'</div></div>' +
        '<div class="qty"><button aria-label="'+I18N.dec+'">−</button><span>'+li.quantity+'</span><button aria-label="'+I18N.inc+'">+</button></div>' +
        '<button class="rm" aria-label="'+I18N.remove+'">✕</button>';
      const btns = d.querySelectorAll(".qty button");
      if(li._tmp){ btns[0].disabled = btns[1].disabled = true; d.querySelector(".rm").disabled = true; }
      else {
        btns[0].addEventListener("click", ()=>changeLine(li.key, li.quantity-1));
        btns[1].addEventListener("click", ()=>changeLine(li.key, li.quantity+1));
        d.querySelector(".rm").addEventListener("click", ()=>changeLine(li.key, 0));
      }
      items.appendChild(d);
    });
  }
  $("#cartCount").textContent = cart.item_count;
  const FS=5000, bar=$("#shipBar");
  if(bar){
    if(!cart.item_count){ bar.hidden=true; }
    else{
      bar.hidden=false;
      const rem=FS-cart.total_price;
      if(rem>0){ $("#shipMsg").textContent=I18N.shipMore.replace("%s",fmtc(rem)); $("#shipFill").style.width=Math.min(100,cart.total_price/FS*100)+"%"; }
      else{ $("#shipMsg").textContent=I18N.shipOk; $("#shipFill").style.width="100%"; }
    }
  }
  $("#cartTotal").textContent = fmtc(cart.total_price);
}
function refreshCart(){ return fetch("/cart.js",{cache:"no-store"}).then(r=>r.json()).then(renderCart); }

/* quantité : affichage immédiat, envoi regroupé 200 ms plus tard (un seul appel même si on clique 5 fois) */
function changeLine(key, q){
  q = Math.max(0, q);
  if(CART){
    const c = clone(CART), li = c.items.find(i=>i.key===key);
    if(li){
      const delta = q - li.quantity;
      c.item_count += delta; c.total_price += li.price*delta;
      if(q<=0) c.items = c.items.filter(i=>i.key!==key); else li.quantity = q;
      renderCart(c);
    }
  }
  clearTimeout(PENDING[key]);
  PENDING[key] = setTimeout(()=>{
    delete PENDING[key];
    fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:key, quantity:q})})
      .then(r=>{ if(!r.ok) throw 0; return r.json(); })
      .then(cart=>{ if(!Object.keys(PENDING).length) renderCart(cart); })
      .catch(refreshCart);
  }, 200);
}

/* ajout : la ligne apparaît instantanément (meta = titre/prix/image connus côté page), le serveur confirme ensuite */
function addToCart(vid, q, meta){
  q = q || 1;
  if(CART){
    const c = clone(CART), li = c.items.find(i=>String(i.variant_id)===String(vid));
    if(li){ li.quantity += q; c.total_price += li.price*q; c.item_count += q; renderCart(c); }
    else if(meta){
      c.items.unshift({key:"tmp-"+vid, variant_id:Number(vid), product_title:meta.title||"", variant_title:meta.variant||"", price:meta.price||0, quantity:q, image:meta.image||"", handle:meta.handle||"", _tmp:true});
      c.total_price += (meta.price||0)*q; c.item_count += q; renderCart(c);
    }
  }
  return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:Number(vid), quantity:q})})
    .then(r=>{ if(!r.ok) throw 0; return refreshCart(); })
    .catch(err=>refreshCart().then(()=>{ throw err; }));
}

window.Noir = { add:addToCart, openDrawer:openDrawer };

/* ---- garde-fou : aucun titre ne déborde jamais ---- */
function fitTitles(){
  document.querySelectorAll(".giant,.mmlinks a,.prorow .w,.offer .w").forEach(el=>{
    el.style.fontSize="";
    if(!el.clientWidth) return;
    let fs = parseFloat(getComputedStyle(el).fontSize), guard=40;
    while(el.scrollWidth > el.clientWidth + 1 && fs > 14 && guard--){
      fs -= 1; el.style.fontSize = fs + "px";
    }
  });
}
if(document.fonts && document.fonts.ready) document.fonts.ready.then(fitTitles);
addEventListener("load", fitTitles);
addEventListener("resize", ()=>{ clearTimeout(window.__ft); window.__ft = setTimeout(fitTitles, 120); });


document.addEventListener("DOMContentLoaded", function(){

  /* ---- galerie : ajout direct (mouture par défaut = 1ʳᵉ variante) + pan ---- */
  const gal = document.getElementById("boutique") || document.querySelector(".gallery");
  if(gal){
    gal.querySelectorAll(".cell img").forEach(imgFallback);
    gal.querySelectorAll(".cell").forEach((cell)=>{
      const d = DATA[hkey(cell.dataset.handle)];
      cell.style.setProperty("--oy", (d ? d.oy : 54) + "%");
      cell.dataset.pyd = d ? d.pyd : 3;
      const flash = (el, base)=>{ el.textContent=I18N.added; setTimeout(()=>{ el.textContent=base; },1100); };
      const cellMeta = ()=>{ let variant=""; try{ const vs=JSON.parse(cell.dataset.variants||"[]"); if(vs.length) variant=vs[0].t; }catch(e){} const im=cell.querySelector("img"); return {title:cell.dataset.title, price:+cell.dataset.price||0, image:im?(im.currentSrc||im.src):"", handle:cell.dataset.handle, variant}; };
      const doAdd = (el)=>{ const base=el.textContent; flash(el,base); openDrawer(); addToCart(cell.dataset.vid,1,cellMeta()).catch(()=>{}); };
      const chip = cell.querySelector(".zoomchip");
      if(chip){
        chip.addEventListener("click", e=>{ e.preventDefault(); e.stopPropagation(); doAdd(chip); });
        chip.addEventListener("keydown", e=>{ if(e.key==="Enter"||e.key===" "){ e.preventDefault(); e.stopPropagation(); doAdd(chip); }});
      }
      const ca = cell.querySelector(".cadd2");
      if(ca) ca.addEventListener("click", e=>{ e.preventDefault(); e.stopPropagation(); doAdd(ca); });
    });
  }

  /* ---- page produit : specs + quantité + ajout AJAX ---- */
  const pp = document.querySelector(".pp");
  if(pp){
    const pim = pp.querySelector(".photo img"); if(pim) imgFallback(pim);
    const d = DATA[hkey(pp.dataset.handle)];
    if(d){
      const dot = pp.querySelector("[data-dot]"); if(dot) dot.style.background = d.color;
      const orig = pp.querySelector("[data-orig]");
      if(orig) orig.textContent = pickL(d.origin) + " · SCA " + d.sca;
      const fl = pp.querySelector("[data-flav]"); if(fl) fl.textContent = pickL(d.flav);
      const tb = pp.querySelector("[data-specs]");
      if(tb) tb.innerHTML = specRows(d.specs);
      const g = pp.querySelector("[data-g]");
      if(g){
        g.innerHTML = gaugeHtml(d);
        requestAnimationFrame(()=>requestAnimationFrame(()=>{
          g.querySelectorAll("i").forEach(i=>i.style.setProperty("--v", i.dataset.v));
        }));
      }
    }
    let q = 1;
    const qEl = pp.querySelector("[data-q]"), qIn = pp.querySelector("[data-qty]");
    pp.querySelector("[data-minus]").addEventListener("click", ()=>{ q=Math.max(1,q-1); qEl.textContent=q; qIn.value=q; });
    pp.querySelector("[data-plus]").addEventListener("click", ()=>{ q++; qEl.textContent=q; qIn.value=q; });
    const vseg = pp.querySelector(".vopt .vseg");
    if(vseg){
      vseg.addEventListener("click", e=>{
        const b = e.target.closest("button[data-v]"); if(!b || b.disabled) return;
        const vo = vseg.closest(".vopt");
        vo.classList.remove("err");
        document.getElementById("ppForm").querySelector('[name="id"]').value = b.dataset.v;
        vseg.querySelectorAll("button").forEach(x=>{ x.classList.toggle("on", x===b); x.setAttribute("aria-pressed", x===b ? "true" : "false"); });
      });
    }
    const form = document.getElementById("ppForm");
    if(form) form.addEventListener("submit", e=>{
      e.preventDefault();
      const vid = form.querySelector('[name="id"]').value;
      if(!vid){
        const vo = form.querySelector(".vopt");
        if(vo){ vo.classList.add("err"); const s = vo.querySelector("select"); if(s) s.focus(); }
        return;
      }
      const sb = form.querySelector('button[type="submit"]'); const base = sb ? sb.textContent : "";
      const on = form.querySelector(".vseg button.on"); const pim = pp.querySelector(".photo img");
      const meta = {title: pp.dataset.title || "", price: +pp.dataset.price || 0, image: pim ? (pim.currentSrc||pim.src) : "", handle: pp.dataset.handle, variant: on ? on.textContent.replace("✓","").trim() : ""};
      if(sb){ sb.textContent=I18N.added; setTimeout(()=>{ sb.textContent=base; },1100); }
      openDrawer();
      addToCart(vid, q, meta).catch(()=>{});
    });
  }


  /* ---- légendes galerie (origine — notes, traduites) ---- */
  if(gal){
    [].slice.call(gal.querySelectorAll(".cell")).forEach(c=>{
      const d = DATA[hkey(c.dataset.handle)], n = c.querySelector("[data-note]");
      if(d && n) n.textContent = pickL(d.origin) + " — " + pickL(d.flav);
      else if(n) n.textContent = "";
    });
  }

  /* ---- popup produit ---- */
  const modal = $("#modal");
  if(modal && gal){
    const cells = [].slice.call(gal.querySelectorAll(".cell"));
    let mi = 0, mq = 1;
    function fillM(i){
      mi = (i + cells.length) % cells.length; mq = 1; $("#mQty").textContent = 1;
      const c = cells[mi], d = DATA[hkey(c.dataset.handle)] || {};
      const cim = c.querySelector("img"); $("#mImg").src = cim.currentSrc || cim.src; $("#mImg").alt = c.dataset.title || "";
      $("#mDot").style.background = d.color || "#1a1512";
      $("#mName").textContent = c.dataset.title || "";
      $("#mOrig").textContent = pickL(d.origin) ? pickL(d.origin) + " · SCA " + d.sca : "";
      $("#mFlav").textContent = pickL(d.flav) || "";
      $("#mSpecs").innerHTML = specRows(d.specs);
      const g = $("#mG");
      if(d.a){
        g.innerHTML = gaugeHtml(d);
        requestAnimationFrame(()=>requestAnimationFrame(()=>{
          g.querySelectorAll("i").forEach(el=>el.style.setProperty("--v", el.dataset.v));
        }));
      } else g.innerHTML = "";
      $("#mPrice").innerHTML = fmtc(+c.dataset.price || 0) + ' <span>/ 200 g</span>';
      const vw = $("#mVopt");
      if(vw){
        if(c.dataset.variants){
          const vs = JSON.parse(c.dataset.variants);
          $("#mVlab").textContent = c.dataset.optname || "";
          $("#mVerr").textContent = I18N.grindReq;
          /* mouture par défaut : la première variante (grains entiers) est présélectionnée */
          $("#mVseg").innerHTML = vs.map((v,i)=>'<button type="button" data-v="'+v.id+'"'+(i===0?' class="on" aria-pressed="true"':' aria-pressed="false"')+'>'+v.t+'</button>').join("");
          vw.dataset.sel = vs.length ? String(vs[0].id) : "";
          vw.classList.remove("err");
          vw.hidden = false;
        } else vw.hidden = true;
      }
      $("#mLink").href = c.getAttribute("href");
    }
    function openM(i){ fillM(i); modal.classList.add("open"); $("#overlay").classList.add("open"); document.body.style.overflow = "hidden"; }
    function closeM(){ modal.classList.remove("open"); $("#overlay").classList.remove("open"); if(!$("#drawer").classList.contains("open")) document.body.style.overflow = ""; }
    function navM(dir){
      modal.classList.add("swap");
      setTimeout(()=>{ fillM(mi + dir); modal.classList.remove("swap"); }, 160);
    }
    cells.forEach((c,i)=>c.addEventListener("click", e=>{
      if(e.target.closest(".add2") || e.target.closest(".cadd2")) return;
      if(e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault(); openM(i);
    }));
    $("#mClose").addEventListener("click", closeM);
    $("#mPrev").addEventListener("click", ()=>navM(-1));
    $("#mNext").addEventListener("click", ()=>navM(1));
    $("#mMinus").addEventListener("click", ()=>{ mq = Math.max(1, mq-1); $("#mQty").textContent = mq; });
    $("#mPlus").addEventListener("click", ()=>{ mq++; $("#mQty").textContent = mq; });
    $("#mAdd").addEventListener("click", ()=>{
      const vw=$("#mVopt");
      let vid = cells[mi].dataset.vid;
      if(vw && !vw.hidden){
        vid = vw.dataset.sel || "";
        if(!vid){ vw.classList.add("err"); return; }
      }
      const c = cells[mi]; const on = $("#mVseg").querySelector("button.on");
      const meta = {title:c.dataset.title, price:+c.dataset.price||0, image:$("#mImg").src, handle:c.dataset.handle, variant: on ? on.textContent.replace("✓","").trim() : ""};
      closeM(); openDrawer();
      addToCart(vid, mq, meta).catch(()=>{});
    });
    $("#mVseg").addEventListener("click", e=>{
      const b = e.target.closest("button[data-v]"); if(!b) return;
      const vw = $("#mVopt");
      vw.dataset.sel = b.dataset.v;
      vw.classList.remove("err");
      $("#mVseg").querySelectorAll("button").forEach(x=>{ x.classList.toggle("on", x===b); x.setAttribute("aria-pressed", x===b ? "true" : "false"); });
    });
    const ov2 = $("#overlay"); if(ov2) ov2.addEventListener("click", closeM);
    document.addEventListener("keydown", e=>{
      if(!modal.classList.contains("open")) return;
      if(e.key === "Escape") closeM();
      if(e.key === "ArrowLeft") navM(-1);
      if(e.key === "ArrowRight") navM(1);
    });
  }

  /* ---- tasses : popup (même fiche modale que les cafés) ---- */
  const cupCards = [].slice.call(document.querySelectorAll(".cup[data-vid]"));
  if(modal && !gal && cupCards.length && !window.__noirCupPopup){
    window.__noirCupPopup = 1;
    let ci = 0, cq = 1;
    const eyeb = modal.querySelector(".eyebrow");
    function fillC(i){
      ci = (i + cupCards.length) % cupCards.length; cq = 1; $("#mQty").textContent = 1;
      const c = cupCards[ci];
      const im = c.querySelector(".cph img");
      $("#mImg").src = im ? im.src : ""; $("#mImg").alt = c.dataset.title;
      $("#mDot").style.display = "none";
      if(eyeb) eyeb.textContent = I18N.cupEyebrow;
      $("#mName").textContent = c.dataset.title;
      $("#mOrig").textContent = c.dataset.dims;
      $("#mFlav").textContent = c.dataset.desc || "";
      $("#mSpecs").innerHTML = JSON.parse(c.dataset.specs).map(s=>"<tr><td>"+s[0]+"</td><td>"+s[1]+"</td></tr>").join("");
      $("#mG").innerHTML = "";
      const vw2=$("#mVopt"); if(vw2) vw2.hidden = true;
      const hasV = !!c.dataset.vid;
      $("#mPrice").innerHTML = c.dataset.pricefmt + ' <span>' + (hasV ? I18N.perPiece : I18N.instore) + '</span>';
      ["#mAdd","#mMinus","#mPlus","#mQty"].forEach(s2=>{ const el=$(s2); if(el) el.style.display = hasV ? "" : "none"; });
      $("#mLink").href = c.dataset.url;
      const nav = cupCards.length > 1 ? "" : "none";
      $("#mPrev").style.display = nav; $("#mNext").style.display = nav;
    }
    function openC(i){ fillC(i); modal.classList.add("open"); $("#overlay").classList.add("open"); document.body.style.overflow = "hidden"; }
    function closeC(){ modal.classList.remove("open"); $("#overlay").classList.remove("open"); if(!$("#drawer").classList.contains("open")) document.body.style.overflow = ""; }
    function navC(dir){ modal.classList.add("swap"); setTimeout(()=>{ fillC(ci + dir); modal.classList.remove("swap"); }, 160); }
    cupCards.forEach((c,i)=>{
      const ph = c.querySelector(".cph a") || c.querySelector(".cph");
      if(ph) ph.addEventListener("click", e=>{
        if(e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault(); openC(i);
      });
    });
    $("#mClose").addEventListener("click", closeC);
    $("#mPrev").addEventListener("click", ()=>navC(-1));
    $("#mNext").addEventListener("click", ()=>navC(1));
    $("#mMinus").addEventListener("click", ()=>{ cq = Math.max(1, cq-1); $("#mQty").textContent = cq; });
    $("#mPlus").addEventListener("click", ()=>{ cq++; $("#mQty").textContent = cq; });
    $("#mAdd").addEventListener("click", ()=>{ const c=cupCards[ci]; closeC(); openDrawer(); addToCart(c.dataset.vid, cq, {title:c.dataset.title, price:parseMoney(c.dataset.pricefmt), image:$("#mImg").src}).catch(()=>{}); });
    const ov3 = $("#overlay"); if(ov3) ov3.addEventListener("click", closeC);
    document.addEventListener("keydown", e=>{
      if(!modal.classList.contains("open")) return;
      if(e.key === "Escape") closeC();
      if(e.key === "ArrowLeft") navC(-1);
      if(e.key === "ArrowRight") navC(1);
    });
  }

  /* ---- menu mobile ---- */
  const mb = $("#menuBtn"), mm = $("#mmenu");
  if(mb && mm){
    const openMM = ()=>{ mm.classList.add("open"); mb.setAttribute("aria-expanded","true"); document.body.style.overflow="hidden"; };
    const closeMM = ()=>{ mm.classList.remove("open"); mb.setAttribute("aria-expanded","false");
      if(!$("#drawer").classList.contains("open") && !($("#modal")&&$("#modal").classList.contains("open"))) document.body.style.overflow=""; };
    mb.addEventListener("click", ()=>mm.classList.contains("open") ? closeMM() : openMM());
    $("#mmClose").addEventListener("click", closeMM);
    document.addEventListener("keydown", e=>{ if(e.key==="Escape") closeMM(); });
  }

  /* ---- tiroir panier ---- */
  const cb = $("#cartBtn");
  if(cb) cb.addEventListener("click", ()=>{ openDrawer(); refreshCart(); });
  const dc = $("#dClose"); if(dc) dc.addEventListener("click", closeDrawer);
  const ov = $("#overlay"); if(ov) ov.addEventListener("click", closeDrawer);
  const ck = $("#checkout"); if(ck) ck.addEventListener("click", ()=>{ window.location.href="/checkout"; });
  document.addEventListener("keydown", e=>{ if(e.key==="Escape") closeDrawer(); });
  refreshCart();
});
})();


/* ---- tasses : ajout panier ---- */
document.addEventListener("DOMContentLoaded", function(){
  if(window.__noirCupBtns) return; window.__noirCupBtns = 1;
  var I18N = window.NOIR_I18N || {added:"Ajouté ✓"};
  document.querySelectorAll(".cadd[data-vid]").forEach(function(b){
    b.addEventListener("click", function(){
      var t = b.textContent; b.textContent = I18N.added;
      setTimeout(function(){ b.textContent = t; }, 1100);
      window.Noir.openDrawer();
      var card = b.closest(".cup"); var im = card ? card.querySelector(".cph img") : null;
      window.Noir.add(b.dataset.vid, 1, card ? {title:card.dataset.title, price:(function(s){var n=String(s||"").replace(/[^\d,.]/g,"").replace(",","."); var v=parseFloat(n); return isNaN(v)?0:Math.round(v*100);})(card.dataset.pricefmt), image: im ? (im.currentSrc||im.src) : ""} : null).catch(function(){});
    });
  });
  /* nav déroulante : repli après clic */
  document.querySelectorAll(".navgrp .sub a").forEach(function(a){
    a.addEventListener("click", function(){
      var g = a.closest(".navgrp"); g.classList.add("snap");
      setTimeout(function(){ g.classList.remove("snap"); }, 400);
    });
  });
});
